import { DATE_FORMAT, formatNumber } from "helpers/common";
import React from "react";
import { Dropdown } from "react-bootstrap";
import styles from "./winnerList.module.css";

const Columns = ({}) => [
  {
    dataField: "username",
    text: "Name",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.userDetails?.username}</span>
    ),
  },
  {
    dataField: "telegram_username",
    text: "Telegram Username",
    formatter: (_, row) => (
      <span className="text-capitalize">
        {row?.userDetails?.telegram_username}
      </span>
    ),
  },
  {
    dataField: "first_name",
    text: "First Name",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.userDetails?.first_name}</span>
    ),
  },
  {
    dataField: "selectedGames",
    text: "Selected Games",
    formatter: (_, row) => {
      return (
        <Dropdown className={``}>
          <Dropdown.Toggle
            variant="transparent"
            id="dropdown-basic"
            className="rounded-2 d-flex align-items-center justify-content-center px-1 border-0"
          >
            <span className="text-capitalize"></span>
            See all....
          </Dropdown.Toggle>

          <Dropdown.Menu className={` p-0 pb-2`}>
            <span
              className={`${styles.dropIcn} test dropIcn position-absolute`}
              style={{
                left: 16,
                top: 2,
                transform: "translateY(-100%) ",
              }}
            ></span>
            <ol className="list-unstyled ps-0 mb-0">
              {row?.selectedGames.length > 0 ? (
                row?.selectedGames?.map((item, key) => (
                  <li key={key} style={{borderBottom: "1px dashed #ddd"}} className="d-flex align-items-center justify-content-between px-2">
                    <span
                      className="d-flex align-items-center  py-1"
                    >
                      {item?.roundId || 0}
                    </span>
                    <span
                      className="d-flex align-items-center  py-1"
                    >
                      {item?.lineCount || 0}
                    </span>
                  </li>
                ))
              ) : (
                <li className="d-flex align-items-center  px-2 text-muted">
                  No games selected
                </li>
              )}
            </ol>
          </Dropdown.Menu>
        </Dropdown>
      );
    },
  },
  {
    dataField: "gameCount",
    text: "Game Count",
    formatter: (_, row) => (
      <span className="text-capitalize">{formatNumber(row?.gameCount)}</span>
    ),
  },
];

export default Columns;
